export default __webpack_public_path__ + "static/media/jobSeeker.c7905e08.png";